<template>
	<div class="dashboard">
		<top-header></top-header>
       
		<b-container fluid class=" mt-2">
			
            <b-row class="mb-4" style="margin-top: 8%;">
                <b-col cols="12" md="12" class="px-4 d-block d-sm-block text-center">
                   
						  <div class="card mb-2" style="max-width: 40rem;margin-left: 25%;">
							
								<div class="card-body" >
									
									<!--<h3 class="card-title text-center">Thanks You</h3>-->
									  <p class="text-center promo-title" style="padding-top: 26px;">Thank You!</p>
									   <div class=" pt-1 d-none d-md-block" style="font-size:24px;">You have successfully registered for the Training Program!</div>
									  <!-- <p style="padding-bottom: 20px;"><small>You'll shortly receive an email with next steps!</small></p> -->
									   <p style="padding-bottom: 5px;"><small>We’ll be soon sending out the meeting invite over registered email id.</small></p> 
									   <p style="margin: 0px;line-height: 8px;"><small>Our team will get in touch with all necessary details.</small></p>
									   <p style="padding-bottom: 20px;"><small>Please keep exploring Alluraa website and <b-link href="/faq" style="color: #c85df7;">FAQ</b-link> Section for more information.</small></p>
								</div>
							</div>
					
                </b-col> 
			</b-row>
			
		</b-container>
		<b-container fluid>
					<b-row class="mb-4">
						<b-col class="text-center">
						 <div class="py-2 section-title text-center"> KEEP IN TOUCH</div>
						  <ul class="socialFooterThank p-0">
							
							<li><a href="https://www.facebook.com/AlluraaTech" target="_blank" class="facebook"><i class="fa fa-facebook"></i></a></li>
							<li><a href="https://twitter.com/AlluraaTech" target="_blank" class="twitter"><i class="fa fa-twitter"></i></a></li>
							<li><a href="https://www.youtube.com/channel/UCSQjbB7kmloX7R74KK1w1SQ" target="_blank" class="youtube"><i class="fa fa-youtube"></i></a></li>
							<li><a href="https://www.linkedin.com/company/alluraa/" target="_blank" class="linkedin"><i class="fa fa-linkedin"></i></a></li> 
							<li><a href="https://www.instagram.com/alluraaTech" target="_blank" class="instagram"><i class="fa fa-instagram"></i></a></li>
							<li><a href="https://web.whatsapp.com/send?text=&phone=918920670756" target="_blank" class="Whatsapp"><i class="fa fa-whatsapp"></i></a></li> 
							</ul>
						</b-col>
					</b-row>
					<b-row class="mb-4">
						<b-col class="text-center">
						
						
						</b-col>
					</b-row>
		
			
		</b-container>
		<top-footer></top-footer>
		
	</div>
</template>
<script>
/*import Header from "@/components/header-promo.vue";
import Footer from "@/components/footer-promo.vue";*/
import Header from "@/components/header.vue";
import Footer from "@/components/footer.vue";


export default {
	name: 'Dashboard',
	beforeCreate: function() {
        document.body.className = 'promo';
    },
	components: {
        "top-header": Header,
		"top-footer": Footer,
		
	},
	mounted(){ 
        /*let recaptchaScript = document.createElement('script');
        recaptchaScript.setAttribute('src', 'https://www.googletagmanager.com/gtag/js?id=G-J5D103H4N0');
        document.head.appendChild(recaptchaScript);

        let s1 = document.createElement('script');
        s1.setAttribute('src', 'https://www.alluraa.com/js/js_main.js');
        document.head.appendChild(s1); */
       // this.initload();
        
	},
	data() {
		return{
            modal_data: {
                price: 0,
                special_price: 0
            },
            mainProps: { fluidGrow: true, class: 'm1' },
			slide:0,
			related_products: [],
			url: this.$root.WEBURL+'relatedproducts',
			
		};
	},
	methods: {
		showQuickView(item){
			this.modal_data = Object.assign({}, item);
			this.modal_data.gallery_images = JSON.parse(item.gallery_images);
			this.share_data_qty = 1;
			this.$root.$emit('bv::show::modal', 'qv-modal')
		},
		
	},
	metaInfo() {
		return{
			title: 'Alluraa',
			titleTemplate: null,
			meta: [
				{ charset: 'utf-8' },
				{ name: 'keywords', content: 'alluraa' },
                { name: 'description', content: 'alluraa' },
                { name: 'google-site-verification', content: 'C0WP9JxlesVhxC-oa2ieqde4w5HvgBehOytgMpiNktA' },
				{ name: 'viewport', content: 'width=device-width, initial-scale=1' },
				{ name:'facebook-domain-verification', content: '2okv5b4k146l9790zmzgh73w2fwuaa' }
			]
		}
	}
}


</script>
<style scoped lang="scss">
	
	.socialFooterThank li{
    display: inline-block;
    margin: 0px 8px 0px 0px;
    float: none !important;
    width: auto !important;
    /* font-size: 34px; */
    border: 1px solid #c6c6;
    padding: 4px 14px;
    border-radius: 5px;
    width: 50px;
    background: #c6c6c661;
}
</style>
